import { Api } from '@/munio/api/base'
import Action from './Action'
import { URLParams } from '@/munio/http'
import {
  CollectionResponse,
  IntegrationResourceDto,
  IntegrationActionResourceDto,
  ResourceResponse,
} from '@/munio/api/data'

class Integrations extends Api<{ integration: number }> {
  constructor(public id: number) {
    super({
      integration: id,
    })
  }

  get() {
    return this.$get<ResourceResponse<IntegrationResourceDto>>(this.$route('api.web.integration'))
  }

  changeMode(mode: string) {
    return this.$put<ResourceResponse<IntegrationResourceDto>>(this.$route('api.web.integration.mode', { mode }))
  }

  changeOptions(options: Record<string, unknown>) {
    return this.$put<ResourceResponse<IntegrationResourceDto>>(this.$route('api.web.integration.options'), options)
  }

  /*
  addCourse(courseId: number) {
    return this.$post<ResourceResponse<IntegrationResourceDto>>(this.$route('api.web.integration.courses.add'), {
      courseId,
    })
  }

  removeCourse(courseId: number) {
    return this.$delete<ResourceResponse<IntegrationResourceDto>>(this.$route('api.web.integration.courses.remove'), {
      courseId,
    })
  }
  */

  actionsTrigger(action: string) {
    return this.$http.post<ResourceResponse<IntegrationActionResourceDto>>(
      this.$route('api.web.integration.actions.trigger'),
      {
        action,
      },
    )
  }

  actions(options?: URLParams) {
    return this.$get<CollectionResponse<IntegrationActionResourceDto>>(
      this.$route('api.web.integration.actions'),
      this.$query(options),
    )
  }

  action(ulid: string) {
    return new Action(this.params.integration, ulid)
  }
}

export default Integrations
